import { GAME_ID, ActivityWindowType, LevelStage } from '../../data/constants';

const initialState = {
  // Landing page is ProgressView
  windowType: ActivityWindowType.LOADING,
  // Default is STANDARD because it's the safest entry
  // (there should always be data)
  stage: LevelStage.STANDARD,
  // Default is 0 because 0 is the OnboardingItem
  level: 0,
  // Manages ScrollView
  scrollEnabled: true,
  autoPressingDoneButton: false,
  // For logging
  reporter: undefined,
};

/**
 * These are all super self-explanatory
 *
 * Quick Refs:
 * SET_WINDOW_TYPE
 * SET_LEVEL_STAGE
 * SET_LEVEL
 * INCREMENT_LEVEL
 * SET_BACK_BUTTON
 * SET_BOWL_STATE
 */
const stagingReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case 'SET_WINDOW_TYPE':
      return {
        ...state,
        windowType: payload.windowType,
        autoPressingDoneButton: false,
      };
    case 'SET_LEVEL_STAGE':
      return {
        ...state,
        stage: payload.stage,
      };
    case 'SET_LEVEL':
      return {
        ...state,
        level: payload.level,
      };
    case 'PRESS_ONBOARDING_DONE_BUTTON':
      return {
        ...state,
        autoPressingDoneButton: true,
      };
    case 'INCREMENT_LEVEL':
      return {
        ...state,
        level: state.level + 1,
      };
    case 'TOGGLE_SCROLL':
      return {
        ...state,
        scrollEnabled: payload.scrollEnabled,
      };
    default:
      return state;
  }
};

export default stagingReducer;
